import { Button, Card, Popconfirm, Popover, Spin, Tag } from "antd";
import { useState } from "react";
import {
  DeleteFilled,
  EyeOutlined,
  LoadingOutlined,
  GlobalOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export default function GameBox(props) {
  const Navigate = useNavigate();
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <Card
        style={{ width: "100%", borderRadius: 8 }}
        cover={
          <div style={{ position: "relative" }}>
            {props.game_ribbon && (
              <Tag
                color={
                  props.game_ribbon === "UNPUBLISHED"
                    ? "gold"
                    : props.game_ribbon === "Included in Package"
                      ? "green"
                      : "default"
                }
                style={{
                  position: "absolute",
                  top: 10,
                  left: 10,
                  zIndex: 1,
                  fontWeight: "bold",
                }}
              >
                {props.game_ribbon}
              </Tag>
            )}

            <div style={{ width: "100%", position: "relative" }}>
              {!imgLoaded && (
                <div
                  style={{
                    width: "100%",
                    height: 200,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <Spin
                    indicator={
                      <LoadingOutlined style={{ fontSize: 24 }} spin />
                    }
                  />
                </div>
              )}

              <div
                style={{
                  position: "relative",
                  overflow: "hidden",
                  borderRadius: "8px 8px 0px 0px",
                  minHeight: "26vh",
                }}
              >
                <img
                  src={props.game_image}
                  alt="game"
                  onLoad={() => setImgLoaded(true)}
                  onError={() => setImgLoaded(false)}
                  style={{
                    width: "100%",
                    display: imgLoaded ? "block" : "none",
                  }}
                />
              </div>
            </div>
          </div>
        }
        actions={[
          <Popover content={"Game details"}>
            <Button
              color="default"
              variant="filled"
              size="small"
              onClick={() => Navigate("/edit-game/" + props.id)}
            >
              <EyeOutlined />
            </Button>
          </Popover>,

          <Popover
            content={
              props.game_status
                ? "View game learners"
                : "View game learners (First publish the game then assign)"
            }
          >
            {props.game_status ? (
              <Button
                size="small"
                color="default"
                variant="filled"
                onClick={() => {
                  localStorage.setItem("game_title", props.game_title);

                  Navigate("/game-learners/" + props.id, {
                    state: { title: props.game_title },
                    from: window.location.pathname,
                  });
                }}
              >
                <UserOutlined />
                {props.users_count}
              </Button>
            ) : (
              <Button size="small" color="default" variant="filled" disabled>
                <UserOutlined />
                {props.users_count}
              </Button>
            )}
          </Popover>,

          <Popconfirm
            title="Are you sure you want to delete this game?"
            onConfirm={props.deleteGame}
            okText="Yes"
            cancelText="No"
          >
            <Button size="small" color="default" variant="filled">
              <DeleteFilled />
            </Button>
          </Popconfirm>,
          <Popconfirm
            title={
              props.game_status
                ? "Are you sure you want to unpublish this game?"
                : "Are you sure you want to publish this game?"
            }
            onConfirm={() => props.publishGame()}
            okText="Yes"
            cancelText="No"
          >
            <Button
              size="small"
              type="primary"
              style={{
                backgroundColor: props.game_status ? "#52c41a" : "#faad14",
                borderColor: props.game_status ? "#52c41a" : "#faad14",
              }}
            >
              {props.game_status ? <GlobalOutlined /> : <LockOutlined />}
            </Button>
          </Popconfirm>,
        ]}
      >
        <Card.Meta
          title={props.game_title}
          description={
            <div style={{ fontSize: 12, color: "#888" }}>
              Updated At: {props.updated_at}
            </div>
          }
        />
      </Card>
    </div>
  );
}
